import api from '../api/axios';
import { Cohorte } from '../types/coordinacion';

export interface SetFechaPayload {
  paso_id: number;
  ano: number;
  semestre: number;
  fecha: string | null; // fecha de entrega ("YYYY-MM-DDTHH:MM" o null para limpiar)
  fecha_correccion: string | null; // plazo de los revisores
}

export const coordinacionService = {
  /** Cohortes (etapa + período) con su fecha de entrega. Solo coordinador (staff). */
  listCohortes: async (): Promise<Cohorte[]> => {
    const { data } = await api.get<Cohorte[]>('coordinacion/calendario/');
    return data;
  },

  /** Fija la fecha de entrega de una cohorte (aplica a todos sus procesos). */
  setFecha: async (payload: SetFechaPayload) => {
    const { data } = await api.put('coordinacion/calendario/', payload);
    return data;
  },
};
